import { render, staticRenderFns } from "./petEffect.vue?vue&type=template&id=544bfd36&scoped=true"
import script from "./petEffect.vue?vue&type=script&lang=js"
export * from "./petEffect.vue?vue&type=script&lang=js"
import style0 from "./petEffect.vue?vue&type=style&index=0&id=544bfd36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544bfd36",
  null
  
)

export default component.exports